// Page
export const ROUTE_CHANGE = 'ROUTE_CHANGE'

// Rate My Delivery
export const RATE_MY_DELIVERY_MODAL_CHANGE = 'RATE_MY_DELIVERY_MODAL_CHANGE'
export const RATE_MY_DELIVERY_MODAL_VIEWED = 'Delivery Rating Modal Viewed'
export const RATE_MY_DELIVERY_SUBMITTED = 'Delivery Rating Submitted'
export const RATE_MY_DELIVERY_SUBMISSION_COMPLETED =
  'Delivery Rating Submission Completed'
export const RATE_MY_DELIVERY_SUBMISSION_FAILED =
  'Delivery Rating Submission Failed'
export const RATE_MY_DELIVERY_RATED = 'RATE_MY_DELIVERY_RATED'
